import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3565e122")

_pushScopeId("data-v-3565e122")
const _hoisted_1 = { class: "controls" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "controls__header" }, " Stel uw resultaat bij ", -1)
const _hoisted_3 = { class: "controls__body" }
const _hoisted_4 = { class: "controls__section" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, " Mijn bruto oude loon per jaar ", -1)
const _hoisted_6 = { class: "controls__section" }
const _hoisted_7 = { class: "controls__section" }
const _hoisted_8 = { class: "controls__section" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Bent u "),
  /*#__PURE__*/_createVNode("strong", null, "duurzaam"),
  /*#__PURE__*/_createTextVNode(" arbeidsongeschikt?")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")
  const _component_Slider = _resolveComponent("Slider")
  const _component_CheckBox = _resolveComponent("CheckBox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_CurrencyInput, {
          modelValue: _ctx.state.salary,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.state.salary = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("p", null, _toDisplayString(_ctx.state.age) + " jaar oud", 1),
        _createVNode(_component_Slider, {
          modelValue: _ctx.state.age,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.state.age = $event)),
          max: 65,
          min: 16
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("p", null, _toDisplayString(_ctx.disabilityPercent) + "% arbeidsongeschikt", 1),
        _createVNode(_component_Slider, {
          modelValue: _ctx.disabilityPercent,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.disabilityPercent = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("p", null, _toDisplayString(_ctx.formattedIncome) + " bruto bijverdiensten per maand", 1),
        _createVNode(_component_Slider, {
          modelValue: _ctx.extraMonthlyIncome,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.extraMonthlyIncome = $event)),
          max: _ctx.grossMonthlySalary
        }, null, 8, ["modelValue", "max"])
      ]),
      _createVNode("div", {
        class: ["controls__section", { 'controls__section--hidden': !_ctx.hasHighDisability }]
      }, [
        _hoisted_9,
        _createVNode(_component_CheckBox, {
          modelValue: _ctx.state.cannotRecover,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.state.cannotRecover = $event)),
          inline: "",
          label: "Ja"
        }, null, 8, ["modelValue"])
      ], 2)
    ])
  ]))
})